<template>
  <ViewTransition>
    <div id="gtm-prices" class="Prices" v-window-resize="updateBoundings">
      <FixedWatermark :text="model.span" />
      <PricesHeader :active="active" />
      <PricesSectionList
        :sections="sections"
        :mockText="mockText"
        :homeTitle="model.title"
        :homeDesc="model.description"
        :ctaText="ctaText"
        :span="model.span"
        :width="width"
        :height="height"
        @activeChange="onActiveChange"
      />
    </div>
  </ViewTransition>
</template>

<script>
import dataPrices from "@/data/prices.json";
import ViewTransition from "@/transitions/ViewTransition.vue";
import FixedWatermark from "@/components/FixedWatermark";
import PricesHeader from "@/components/PricesHeader";
import PricesSectionList from "@/components/PricesSectionList";
import TagFunctions from "@/assets/tagFunctions.js"

export default {
  name: "Prices",
  data: () => ({
    dataPrices,
    active: 0,
    width: 0,
    height: 0,
  }),
  components: {
    ViewTransition,
    FixedWatermark,
    PricesHeader,
    PricesSectionList,
  },
  mounted() {
    this.updateBoundings();
    TagFunctions.evPagePush('Premios')
  },
  methods: {
    onActiveChange(index) {
      this.active = index;
    },
    updateBoundings() {
      this.height = window.innerHeight;
      this.width = window.innerWidth;
    },
  },
  computed: {
    model() {
      const { main } = this.dataPrices;
      return main;
    },
    sections() {
      const { sectionsMob, sectionsDes } = this.dataPrices;
      const _sections = this.width >= 1100 ? sectionsDes : sectionsMob;
      return _sections;
    },
    mockText() {
      const { mockText } = this.dataPrices;
      return mockText;
    },
    ctaText() {
      const { ctaDes, ctaMob } = this.model;
      const _ctaText = this.width >= 1100 ? ctaDes : ctaMob;
      return _ctaText;
    },
  },
};
</script>

<style lang="stylus" scoped>
@import './Prices.styl';
</style>
